import { TeacherProfileVO } from './types';

interface TeacherProfileMainProps {
    teacherProfileVO: TeacherProfileVO,
}

/**
 * Conditionally renders a banner telling you it's this teacher's birthday. Traditionally referred to as the
 * "birthday doodad".
 */
export const BirthdayBanner = ({ teacherProfileVO }: TeacherProfileMainProps) => {
    if (!teacherProfileVO.showBirthdayBanner) {
        return null;
    }

    return (
        <div className="birthday-banner profile-redesign">
            Today is {teacherProfileVO.teacherDetails.prefix} {teacherProfileVO.teacherDetails.displayName}&apos;s
            birthday! Make it extra special by supporting {teacherProfileVO.teacherDetails.possessivePronoun} classroom.
        </div>
    );
};
